import { render, staticRenderFns } from "./DjangoLayout.vue?vue&type=template&id=61304a9d&scoped=true&lang=pug&"
import script from "./DjangoLayout.vue?vue&type=script&lang=js&"
export * from "./DjangoLayout.vue?vue&type=script&lang=js&"
import style0 from "./DjangoLayout.vue?vue&type=style&index=0&id=61304a9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61304a9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
